var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsTableRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DB4446"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.21428C5.72386 7.21428 5.5 7.43814 5.5 7.71428C5.5 7.99043 5.72386 8.21428 6 8.21428L6 7.21428ZM18 8.21429C18.2761 8.21429 18.5 7.99043 18.5 7.71429C18.5 7.43815 18.2761 7.21429 18 7.21429V8.21429ZM14 6.85714H14.5V6.85714L14 6.85714ZM13.2 6V6.5V6ZM10.8 6V5.5V6ZM10 6.85714L9.5 6.85714V6.85714L10 6.85714ZM6 8.21428L18 8.21429V7.21429L6 7.21428L6 8.21428ZM7.1 7.71429V17.1429H8.1V7.71429H7.1ZM8.4 18.5H15.6V17.5H8.4V18.5ZM16.9 17.1429V7.71429H15.9V17.1429H16.9ZM15.6 18.5C16.3499 18.5 16.9 17.8593 16.9 17.1429H15.9C15.9 17.3732 15.7338 17.5 15.6 17.5V18.5ZM7.1 17.1429C7.1 17.8593 7.6501 18.5 8.4 18.5V17.5C8.26625 17.5 8.1 17.3732 8.1 17.1429H7.1ZM14.5 7.71429V6.85714H13.5V7.71429H14.5ZM13.2 5.5L10.8 5.5V6.5L13.2 6.5V5.5ZM9.5 6.85714L9.5 7.71429L10.5 7.71429L10.5 6.85714L9.5 6.85714ZM10.8 5.5C10.0501 5.5 9.5 6.14066 9.5 6.85714L10.5 6.85714C10.5 6.62685 10.6662 6.5 10.8 6.5V5.5ZM14.5 6.85714C14.5 6.14067 13.9499 5.5 13.2 5.5V6.5C13.3338 6.5 13.5 6.62685 13.5 6.85714L14.5 6.85714Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsTableRemove);
export default __webpack_public_path__ + "static/media/products-table-remove.0ef4c44b160d205bf42132451c86ed11.svg";
export { ForwardRef as ReactComponent };